<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <h2 class="title" style="margin-bottom:80px;" color>
            {{ $t("wheel.mainPage.title") }}
          </h2>
          <base-modal
            :title="modalTitle"
            :message="modalMessage"
            :showModal="showModal"
            @close-modal="showModal = false"
          />
          <h4 class="title" style="height: 30px; margin-bottom:80px;" color>
            {{ currentPhrase }}
          </h4>
          <div
            class="row"
            style="justify-content: space-evenly; margin-bottom:10px;"
          >
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('gentle')"
            >
              {{ $t("neverHave.gentleButton") }}
            </button>
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('controversy')"
            >
              {{ $t("neverHave.controversyButton") }}
            </button>
          </div>
          <div
            class="row"
            style="justify-content: space-evenly; margin-bottom:10px;"
          >
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('embarrassing')"
            >
              {{ $t("neverHave.embarrassingButton") }}
            </button>
            <button
              class="btn btn-base btn-fill float-middle"
              @click="drawnRandomPhrase('spicy')"
            >
              {{ $t("neverHave.spicyButton") }}
            </button>
          </div>

          <div slot="footer" style="width:100%">
            <share-footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "src/mixin";

import ShareFooter from "src/components/ShareFooter.vue";
import { gentlePhrases } from "./phrases/gentle";
import { controversyPhrases } from "./phrases/controversy";
import { embarrassingPhrases } from "./phrases/embarrassing";
import { spicyPhrases } from "./phrases/spicy";

export default {
  mixins: [mixin],

  components: {
    ShareFooter,
  },

  data() {
    return {
      currentPhrase: "Clique em um botão para sortear uma frase.",
    };
  },
  methods: {
    drawnRandomPhrase(type) {
      switch (type) {
        case "gentle":
          this.currentPhrase =
            gentlePhrases[Math.floor(Math.random() * gentlePhrases.length)];
          break;
        case "controversy":
          this.currentPhrase =
            controversyPhrases[
              Math.floor(Math.random() * controversyPhrases.length)
            ];
          break;
        case "embarrassing":
          this.currentPhrase =
            embarrassingPhrases[
              Math.floor(Math.random() * embarrassingPhrases.length)
            ];
          break;
        case "spicy":
          this.currentPhrase =
            spicyPhrases[Math.floor(Math.random() * spicyPhrases.length)];
          break;
        default:
          console.error("Can't find this type of deck");
      }
    },
  },
};
</script>

<style>
.title {
  text-align: center;
}
.description {
  text-align: left;
}
</style>
